import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import PropTypes from 'prop-types';
import Icon from '@/components/atoms/icon';
import Input from '@/components/atoms/input';

const GlobalSearch = ({ value, onChange, results = {} }) => {
	const getName = (type) => {
		let name = '';
		let iconName = '';

		switch (type.toLowerCase()) {
			case 'client':
				name = 'Clients';
				iconName = 'clients';
				break;
			case 'policy':
				name = 'Policies';
				iconName = 'policies';
				break;
			case 'renewal':
				name = 'Renewals';
				iconName = 'renewals';
				break;
			case 'claim':
				name = 'Claims';
				iconName = 'claims';
				break;
			case 'complaint':
				name = 'Complaints';
				iconName = 'complaints';
				break;
			case 'task':
				name = 'Tasks';
				iconName = 'tasks';
				break;
			case '3rd_party':
				name = '3rd parties';
				iconName = 'third-parties';
				break;
			case 'manager':
				name = 'Manager';
				iconName = 'manager';
				break;
			case 'admin':
				name = 'Admin';
				iconName = 'admin';
				break;
			default:
				break;
		}

		return { name, iconName };
	};

	return (
		<div className="relative block overflow-visible bg-transparent rounded-none">
			<Input type="search" placeholder="Search" aria-label="Search" value={value} onChange={onChange} />
			{Object.keys(results).length > 0 && (
				<div className="absolute left-0 right-0 mt-1 bg-white border rounded-md top-full shadow-drop-shadow border-formOutline max-h-[300px] overflow-y-auto overflow-x-hidden">
					{Object.keys(results).map((type, idx) => (
						<ul key={`${type}-${idx}`}>
							<li className="mb-1 last:mb-0">
								<p className="px-2 mx-2 py-2.5 text-sm font-bold leading-eis-18 text-eis-black">{getName(type).name}</p>
								{results[type].map((result) => (
									<a href={result.href} target="_blank" key={result.id} className="flex flex-row gap-2 p-2 mx-1 mt-1" title={result.name}>
										<Icon name={getName(type).iconName} className="text-eis-grey-87" />
										<p className="flex flex-col">
											<span
												className="block mb-2 text-sm text-eis-black leading-eis-18 last:mb-0"
												dangerouslySetInnerHTML={{ __html: result.highlightedText }}
											></span>
										</p>
									</a>
								))}
							</li>
						</ul>
					))}
				</div>
			)}
			{value && !Object.keys(results).length && (
				<div className="absolute left-0 right-0 mt-1 bg-white border rounded-md top-full shadow-drop-shadow border-formOutline max-h-[300px] overflow-y-auto overflow-x-hidden">
					<p className="py-6 text-sm font-normal text-center leading-eis-18 text-eis-black">No results found.</p>
				</div>
			)}
		</div>
	);
};

GlobalSearch.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onChange: PropTypes.func,
};

GlobalSearch.defaultProps = {
	value: '',
	onChange: () => {},
};

export default GlobalSearch;
